import script from "./CommunityPost.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityPost.vue?vue&type=script&setup=true&lang=js"

import "./CommunityPost.vue?vue&type=style&index=0&id=de118fbe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de118fbe"]])

export default __exports__